const solutionRouter = {
  route: null,
  name: null,
  title: '解决方案管理',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-tushuguanli',
  filePath: 'view/solotion/', // 文件路径
  order: null,
  inNav: true,
  children: [
    {
      title: '添加分类',
      type: 'view',
      name: 'SolutionCategoryCreate',
      route: '/solution-category/add',
      filePath: 'view/solution/solution-category-create.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '分类列表',
      type: 'view',
      name: 'SolutionCategoryCreate',
      route: '/solution-category/list',
      filePath: 'view/solution/solution-category-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '添加解决方案',
      type: 'view',
      name: 'SolutionCreate',
      route: '/solution/add',
      filePath: 'view/solution/solution-create.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '解决方案列表',
      type: 'view',
      name: 'SolutionList',
      route: '/solution/list',
      filePath: 'view/solution/solution-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
  ],
}

export default solutionRouter
